
import { useState, useEffect } from 'react';
import { shallowEqual } from '../utils/common.util';

export const useAssignIfChanged = (value: Record<string, unknown>): typeof value => {
  const [val, setVal] = useState(value);

  useEffect(() => {
    if (!shallowEqual(val, value)) {
      setVal(value);
    }
  }, [value]);

  return val;
}
